import { Line } from "react-chartjs-2";
import { Card, CardBody, Col } from 'reactstrap'
import { ChatJSLineChart } from '../../../../Utils/Constants'
import { lineChartData, lineChartDataOption } from "../../../../Data/Charts/ChartJs/ChartJs";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";

const LineChart = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSLineChart} />
        <CardBody className="chart-block">
          <Line id="myLineCharts" data={lineChartData} options={lineChartDataOption} width={778} height={400} />
        </CardBody>
      </Card>
    </Col>
  )
}

export default LineChart